import { Outlet, useParams } from "react-router";

import { ProjectClient } from "@citrine/resources/project";

import { useDocumentTitle } from "#src/hooks/use-document-title";

export function Component() {
  const { projectId } = useParams<{ projectId: string }>();
  const projectQuery = ProjectClient.getInstance().useGet(projectId);
  useDocumentTitle(projectQuery.data?.name);

  return <Outlet />;
}
